import ErrorBoundary from './components/Redesing/error-boundary';
import Root from './routes';
import { RelayProvider } from './relay';

import './css/style.scss';

export default function App() {
  return (
    <ErrorBoundary>
      <RelayProvider>
        <Root />
      </RelayProvider>
    </ErrorBoundary>
  );
}
